import { Component, computed, inject } from '@angular/core';
import { LayoutService } from '@/layout/service/layout.service';

@Component({
    selector: '[app-footer]',
    standalone: true,
    template: `
        <div class="layout-footer">
            <div class="footer-logo-container">
                <img
                    src="/favicon.png"
                    alt="diamond-layout"
                />
                <span class="footer-app-name">Connan</span>
            </div>
            <span class="footer-copyright">&#169; Connan Nutrição Animal - {{ currentYear }}</span>
        </div>
    `
})
export class AppFooter {
    layoutService = inject(LayoutService);
    currentYear = new Date().getFullYear();
    isDarkTheme = computed(() => this.layoutService.isDarkTheme());
}
